import { ImportCsvModal } from 'iron-forge-react-modules';
import * as types from './types';



export const propertyName2Comment: Record<types.NetSuiteDepartmentsPropertyName, string> = {
  internalId: 'internalId',
  name: 'name'
};



export const propertyName2Data: Record<types.NetSuiteDepartmentsPropertyName, ImportCsvModal.IFormatTypeData> = {
  internalId: {
    example: "12",
    properFormat: "",
    fnValidate: () => true
  },
  name: {
    example: "Accounting & Finance",
    properFormat: "",
    fnValidate: () => true
  }
};
